import { Trans, useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { FiltersButton } from '@/design_system/Filters/FiltersButton/FiltersButton';
import { FiltersMenu } from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import InputSearch from '@/design_system/InputSearch';
import Stack from '@/design_system/Stack';
import IconCross from '@/icons/Cross.svg';

import { useFilters } from '../FiltersState';

import { FiltersPermission } from './FiltersPermission';
import { FiltersScope } from './FiltersScope';

export const DesktopFilters = () => {
  const { t } = useLingui();

  const { search, activeFiltersCount, clearFilters } = useFilters();

  return (
    <Stack gap="0.75rem">
      <Stack row gap="1rem" alignItems="center">
        <FiltersMenu button={<FiltersButton />}>
          <FiltersScope />
          <FiltersPermission />
        </FiltersMenu>
        <InputSearch
          ariaLabel={t({
            id: 'settings.organization.roles.search.label',
            message: 'Search roles',
          })}
          placeholder={t({
            id: 'settings.organization.roles.search.placeholder',
            message: 'Search roles...',
          })}
          value={search.search}
          onChange={search.debouncedSetSearch}
          style={{ flex: 1 }}
        />
      </Stack>

      {activeFiltersCount > 0 && (
        <Stack row gap="1rem" justifyContent="space-between" alignItems="center" flexWrap="nowrap">
          <Stack row gap="0.5rem">
            <FiltersScope tag />
            <FiltersPermission tag />
          </Stack>

          <Button
            variant="link-subtle"
            onPress={clearFilters}
            style={{ textWrap: 'nowrap' }}
            size="small"
          >
            <IconCross />
            <Trans id="settings.organization.roles.filters.clear_all">Clear filters</Trans>
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
